<template>
    <span v-b-tooltip.hover
          :class="required ? 'typo-required-field' : ''"
          :title="tooltip">
        {{ label }}
    </span>
</template>

<script>
  export default {
    name: "LabelCustom",
    props: ['label', 'tooltip', 'required'],
  };
</script>
